"use client";

import { useI18n } from "@/i18n/client";
import clsx from "clsx";
import { useProductContext } from "@/providers/ProductContextProvider";
import * as Accordion from "@radix-ui/react-accordion";
import IconArrow from "../../UI/Icon/IconArrow/IconArrow";
import accordionStyles from "../ProductPageAccordian.module.scss";
import styles from "./Specification.module.scss";

interface SpecificationProps {
	isInAccordion: boolean;
}

const Specification: React.FC<SpecificationProps> = ({ isInAccordion }) => {
	const { product } = useProductContext();
	const t = useI18n();
	const customFieldSpecification = product.customFields?.filter((field) =>
		field.name.startsWith("S|"),
	);

	const content = (
		<div className={accordionStyles.widthContainer}>
			<table
				className={clsx([
					styles.specTable,
					!isInAccordion ? styles.onDetails : "",
				])}
			>
				<tbody>
					<tr>
						<th>{t("product.specification.description")}</th>
						<th>{t("product.specification.detail")}</th>
					</tr>
					{product.brand?.name && (
						<tr>
							<th>{t("product.specification.brand")}</th>
							<td>{product.brand.name}</td>
						</tr>
					)}
					{customFieldSpecification?.map((field) => (
						<tr key={field.name}>
							<th>{field.name.slice(2)}</th>
							<td>{field.value}</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);

	if (!customFieldSpecification) return null;

	return isInAccordion ? (
		<Accordion.Item value='Specification'>
			<Accordion.Header>
				<Accordion.Trigger className={accordionStyles.header}>
					<div className={accordionStyles.widthContainer}>
						{t("product.specification.specification")}
						<IconArrow
							direction='down'
							aria-labelledby='directional chevron pointing down'
						/>
					</div>
				</Accordion.Trigger>
			</Accordion.Header>
			<Accordion.Content className={accordionStyles.content}>
				{content}
			</Accordion.Content>
		</Accordion.Item>
	) : (
		content
	);
};

export default Specification;
